import { LitElement, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

import "@phosphor-icons/webcomponents/PhX";

import { styles } from "./wow-centered-dialog.css";

@customElement("wow-centered-dialog")
export class WowCenteredDialog extends LitElement {
  static override styles = [styles];

  @property({ type: String })
  header = "";

  @property({ type: String })
  description = "";

  private mouseDownTarget: EventTarget | null = null;

  private handleOverlayMouseDown = (e: MouseEvent) => {
    this.mouseDownTarget = e.target;
  };

  private handleOverlayMouseUp = (e: MouseEvent) => {
    if (this.mouseDownTarget === e.currentTarget && e.target === e.currentTarget) {
      this.dispatchCloseEvent();
    }
    this.mouseDownTarget = null;
  };

  private handleCloseClick() {
    this.dispatchCloseEvent();
  }

  private handleDialogClick(e: Event) {
    e.stopPropagation();
  }

  private handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      this.dispatchCloseEvent();
    }
  };

  private dispatchCloseEvent() {
    this.dispatchEvent(
      new CustomEvent("close", {
        bubbles: true,
        composed: true,
      }),
    );
  }

  override connectedCallback() {
    super.connectedCallback();
    document.addEventListener("keydown", this.handleKeyDown);
    document.body.style.overflow = "hidden";
  }

  override disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("keydown", this.handleKeyDown);
    document.body.style.overflow = "unset";
  }

  protected override render() {
    return html`
      <div class="overlay" @mousedown=${this.handleOverlayMouseDown} @mouseup=${this.handleOverlayMouseUp}>
        <div class="dialog" @click=${this.handleDialogClick}>
          <div class="header">
            <span class="title">${this.header}</span>
            <button class="close-button" @click=${this.handleCloseClick} aria-label="Close">
              <ph-x size="20"></ph-x>
            </button>
          </div>
          ${this.description ? html`<p class="description">${this.description}</p>` : nothing}
          <div class="buttons">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "wow-centered-dialog": WowCenteredDialog;
  }
}
